import { requestGet } from '../request';
import apiPath from './apiPath';

const api = {
  GetCustomerList(payload: {
    outlet_code: string;
    keyword?: string;
    page?: number;
    page_size?: number;
    sort_by?: string;
    sort_order?: string;
  }) {
    return requestGet(apiPath.OUTLET_USER.path, {
      outlet_code: payload.outlet_code,
      keyword: payload.keyword || '',
      page: payload.page || 1,
      page_size: payload.page_size || 20,
      sort_by: payload.sort_by || 'rm.created_at',
      sort_order: payload.sort_order || 'DESC'
    });
  }
};

export default api;
